import { Link } from "react-router-dom";
import useGetImages from "../hooks/useGetImages";
import { useTheme } from "../context/ThemeContext";
import React from "react";

const ProductCard = ({ item, id }) => {
  const theme = useTheme();
  const { image: uri } = useGetImages("product_pictures", id, item?.URUN_KOD);
  // console.log('item', item)
  if (!item) return null;

  return (
    <Link
      to={`/product/${item?.URUN_KOD}`}
      className="flex bg-white rounded-lg shadow-lg overflow-hidden px-2 py-3 my-2 no-underline"
    >
      <div className="w-2/4">
        <h2 className="text-[14px] font-semibold text-zinc-700">
          {item?.URUN_ADI}
        </h2>
        <p className="text-xs text-zinc-700"
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 4,
            WebkitBoxOrient: 'vertical',
            textOverflow: 'ellipsis',
            overflow: 'hidden',}}>{item?.URUN_ACIKLAMA}</p>
        <p className={`font-bold mt-2 ${theme.primary.text}`}>₺ {item?.FIYATI}</p>
      </div>
      <div className="w-2/4 ml-1 flex flex-row justify-end">
        {!!uri && (
          <img
            src={uri}
            alt={item?.URUN_ADI}
            className="object-cover h-[140px] w-[140px] rounded"
          />
        )}

      </div>
    </Link>
  );
};

export default ProductCard;
